import { Button, Col, Form, Input, Row, Select, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createStore } from "../../actions/store";
import { useNavigate } from "react-router-dom";
import { updateUser } from "../../actions/users";

const CreateStore = ({ currentUser }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [form] = Form.useForm();
  const countries = require("../../utils/countries.json");
  const currency = require("../../utils/currency.json");
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const { Option } = Select;
  const store = JSON.parse(localStorage.getItem("store"));

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const onFinish = (value) => {
    setLoadingButton(true);
    let formData = {
      ...value,
      storeAdmin: currentUser?._id,
    };
    dispatch(createStore(formData, history, setLoadingButton));
  };

  useEffect(() => {
    setTimeout(() => {
      const id = currentUser?._id;
      let userData = {
        store: store?._id,
      };
      if (store?._id) {
        dispatch(updateUser(id, userData, history, setLoadingButton));
      }
    }, 3000);
  }, [store]);

  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center bg-gray-100">
      <p>Welcome! {currentUser?.name}</p>
      <p>Create your store</p>
      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
      >
        <div className="p-4 bg-white shadow">
          <Skeleton loading={loading}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Country" name="country">
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {countries?.length > 0
                      ? countries?.map((country) => (
                          <Option key={country?.code} value={country?.name}>
                            {country?.name}
                          </Option>
                        ))
                      : ""}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Currency" name="currency">
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {currency?.length > 0
                      ? currency?.map((c) => (
                          <Option key={c?.id} value={c?.id}>
                            {c?.name}
                          </Option>
                        ))
                      : ""}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="flex flex-wrap  justify-end gap-4">
                  <Form.Item shouldUpdate style={{ margin: 0 }}>
                    {() => (
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingButton}
                        disabled={!currentUser}
                      >
                        Create
                      </Button>
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Skeleton>
        </div>
      </Form>
    </div>
  );
};

export default CreateStore;
